<template>
    <div class="tabs">
        <div
            class="tab"
            v-for="tab in tabs"
            :key="tab.key"
            :class="[{ current: currentTab === tab.key }, tab.color || '']"
            @click="$emit('change', tab.key)"
        >
            <span>{{ tab.label }}</span>
            <div
                v-if="tab.count"
                class="counter"
            >{{ tab.count }}</div>
        </div>
        <div class="divider"></div>
    </div>
</template>

<script>
export default {
    name: 'AccountTabs',
    model: {
        prop: 'currentTab',
        event: 'change',
    },
    props: {
        currentTab: {
            type: String,
            required: true,
        },
        tabs: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import '@/styles/rem';
@import '@/styles/mrem';

.tabs{
    position: relative;
    display: flex;
    user-select: none;
    cursor: pointer;
    margin-bottom: rem(24);

    @include on-mobile{
        height: auto;
        flex-direction: column;
        align-items: stretch;
        margin-bottom: mrem(48);
    }

    .divider{
        position: absolute;
        z-index: 0;
        height: rem(2);
        background-color: #D2D5D9;
        left: 0;
        right: 0;
        bottom: 0;
        @include on-mobile{
            bottom: mrem(-24);
        }
    }

    .tab{
        position: relative;
        padding: rem(16) rem(24);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #2A2626;
        border-bottom: rem(2) solid transparent;
        z-index: 1;

        .counter{
            position: absolute;
            border-radius: rem(100);
            height: rem(24);
            min-width: rem(24);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: rem(12);
            line-height: rem(20);
            right: 0;
            top: 0;
            padding: 0 rem(8);
            @include on-mobile{
                border-radius: mrem(100);
                height: mrem(24);
                min-width: mrem(24);
                right: mrem(16);
                top: auto;
                font-size: mrem(12);
                line-height: mrem(20);
            }
        }

        @include on-mobile{
            padding: mrem(12) mrem(16);
            border-bottom: none;
            background: #FFFFFF;
            border: 1px solid #D2D5D9;
            border-radius: mrem(4);
            font-weight: bold;
            font-size: mrem(14);
            line-height: mrem(16);
            color: #4663AB;
            justify-content: flex-start;
        }
        &.current{
            color: #4663AB;
            border-bottom-color:#4663AB;

            @include on-mobile{
                background: #4663AB;
                border-color: #4663AB;
                color: white;
                
            }
        }
        &:not(:last-child){
            @include on-mobile{
                margin-bottom: mrem(8);
            }
        }

        &.blue{
            .counter{
                background-color: #4663AB;
                color: #FFFFFF;
            }
        }
        &.red{
            .counter{
                background-color: #EF627D;
                color: #FFFFFF;
            }
        }
        &.grey{
            .counter{
                background-color: #F1F1F1;
                color: #575757;
            }
        }
    }
}
</style>